// extracted by mini-css-extract-plugin
export default {"Content":"Layout_Content__HfjwY","Alert":"Layout_Alert__QTXB0"};